import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var UserService = /** @class */ (function () {
    function UserService(http, config) {
        this.http = http;
        this.config = config;
    }
    UserService.prototype.preferences = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/users/preferences");
    };
    UserService.prototype.activate = function (token) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/users/activate", { token: token });
    };
    UserService.prototype.forgotPassword = function (username) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/users/forgotPassword", { username: username });
    };
    UserService.prototype.current = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/users/current");
    };
    UserService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/users/" + id);
    };
    UserService.prototype.update = function (user) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/users", user);
    };
    UserService.prototype.insert = function (user) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users", user);
    };
    UserService.prototype.delete = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/users/" + id);
    };
    UserService.prototype.register = function (user) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/register", { user: user });
    };
    UserService.prototype.storePreferences = function (p) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/users/preferences", p);
    };
    UserService.prototype.datatable = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/dt", data);
    };
    UserService.prototype.check_wizard_complete = function () {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/wizard/complete", {});
    };
    UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
